<template>
  <div class="wrapper wrapper-content">
    <div class="row">
      <div class="col-lg-3" v-if="userData && userData.type === 'admin'">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <span class="label label-success pull-right">Acumulado</span>
            <h5>Total de Clientes</h5>
          </div>
          <div class="ibox-content">
            <h1 class="no-margins">{{ aggregate ? aggregate.totalCustomers : '0' }}</h1>
            <div
              class="stat-percent font-bold text-info"
              :class="{'danger': percentCustomers.icon === 'down', 'zero': percentCustomers.icon === 'none'}"
            >
              {{ percentCustomers.value }}%
              <i
                v-if="percentCustomers.icon !== 'none'"
                :class="'fa fa-level-'+percentCustomers.icon"
              ></i>
            </div>
            <small>Total de clientes Jaiminho</small>
          </div>
        </div>
      </div>
      <div class="col-lg-3" :class="{'col-lg-4': userData.type !== 'admin'}">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <span class="label label-info pull-right">{{ curMonthName }}</span>
            <h5>Transações</h5>
          </div>
          <div class="ibox-content">
            <h1 class="no-margins">{{ aggregate ? aggregate.totalOrdersCurMonth : '0' }}</h1>
            <div
              class="stat-percent font-bold text-info"
              :class="{'danger': percentOrders.icon === 'down', 'zero': percentOrders.icon === 'none'}"
            >
              {{ percentOrders.value }}%
              <i
                v-if="percentOrders.icon !== 'none'"
                :class="'fa fa-level-'+percentOrders.icon"
              ></i>
            </div>
            <small>Novas vendas pelo Jaiminho</small>
          </div>
        </div>
      </div>
      <div class="col-lg-3" :class="{'col-lg-4': userData.type !== 'admin'}">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <span class="label label-primary pull-right">{{ todayFormatted }}</span>
            <h5>Vendas do dia</h5>
          </div>
          <div class="ibox-content">
            <h1 class="no-margins">{{ aggregate ? aggregate.amountSalesToday: 0 | currency }}</h1>
            <div
              class="stat-percent font-bold text-navy"
              :class="{'danger': percentAmountSalesDay.icon === 'down', 'zero': percentAmountSalesDay.icon === 'none'}"
            >
              {{percentAmountSalesDay.value}}%
              <i
                v-if="percentAmountSalesDay.icon !== 'none'"
                :class="'fa fa-level-'+percentAmountSalesDay.icon"
              ></i>
            </div>
            <small>Total de vendas de hoje</small>
          </div>
        </div>
      </div>
      <div class="col-lg-3" :class="{'col-lg-4': userData.type !== 'admin'}">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <span class="label label-info pull-right">Acumulado</span>
            <h5>Total de vendas</h5>
          </div>
          <div class="ibox-content">
            <h1 class="no-margins">{{ aggregate ? aggregate.amountSalesCurMonth: 0 | currency }}</h1>
            <div
              class="stat-percent font-bold text-info"
              :class="{'danger': percentAmountSalesMonth.icon === 'down', 'zero': percentAmountSalesMonth.icon === 'none'}"
            >
              {{percentAmountSalesMonth.value}}%
              <i
                v-if="percentAmountSalesMonth.icon !== 'none'"
                :class="'fa fa-level-'+percentAmountSalesMonth.icon"
              ></i>
            </div>
            <small>Total de vendas desse mês</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Vendas</h5>
          </div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-lg-12" style="height: 400px;">
                <div class="flot-chart">
                  <BarAndLineChart
                    :labels="labels"
                    :orderCountArray="orderCountArray"
                    :orderAmountArray="orderAmountArray"
                   />
                  <div class="flot-chart-content" id="flot-dashboard-chart"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import "jquery.flot";
import * as firebase from "firebase/app";
import "firebase/firestore";
import BarAndLineChart from "../admin/components/charts/BarAndLineChart";
import { endOfMonth, startOfMonth, sub } from 'date-fns';

export default {
  components: {
    BarAndLineChart
  },
  computed: {
    ...mapGetters(["authUser", "userData"]),
    periodData: function() {
      const aggregate = this.$data.aggregate;
      if(!aggregate) return 0;
      return this.$data.curGraphTab === 'today' ? (aggregate.totalOrdersToday ? aggregate.totalOrdersToday : '0') : ( this.$data.curGraphTab === 'month' ? aggregate.totalOrdersCurMonth : aggregate.totalOrdersCurYear );
    },
    curMonthName: function () {
      return this.$data.months[new Date().getMonth()];
    },
    todayFormatted: function () {
      return new Date().toLocaleDateString();
    },
    percentCustomers: function () {
      const { totalCustomersYesterday, totalCustomersToday } = this.$data.aggregate || {};
      let percent = 0;
      if(!isNaN(totalCustomersYesterday) && !isNaN(totalCustomersToday) && totalCustomersYesterday > 0) {
        percent =
          (totalCustomersToday - totalCustomersYesterday) /
          totalCustomersYesterday;
      }

      return {
        value: percent.toFixed(2),
        icon: percent < 0 ? "down" : percent === 0 ? "none" : "up",
      };
    },
    percentAmountSalesDay: function () {
      const aggregate = this.$data.aggregate;
      let percent = 0;
      if (aggregate) {
        let amountSalesToday = aggregate.amountSalesToday
          ? aggregate.amountSalesToday
          : 0;
        let amountSalesYesterday = aggregate.amountSalesYesterday
          ? aggregate.amountSalesYesterday
          : 0;
        if (amountSalesYesterday === 0) percent = 0;
        else percent = (amountSalesToday - amountSalesYesterday) / amountSalesYesterday;
      }

      return {
        value: (percent * 100).toFixed(2),
        icon: percent < 0 ? "down" : percent === 0 ? "none" : "up",
      };
    },
    percentAmountSalesMonth: function () {
      const aggregate = this.$data.aggregate;
      let percent = 0;
      if (aggregate) {
        let amountSalesInCurMonth = aggregate.amountSalesCurMonth
          ? aggregate.amountSalesCurMonth
          : 0;
        let amountSalesInLastMonth = aggregate.amountSalesLastMonth
          ? aggregate.amountSalesLastMonth
          : 0;
        if (amountSalesInLastMonth === 0) percent = 0;
        else percent = (amountSalesInCurMonth - amountSalesInLastMonth) / amountSalesInLastMonth;
      }

      return {
        value: (percent * 100).toFixed(2),
        icon: percent < 0 ? "down" : percent === 0 ? "none" : "up",
      };
    },
  },
  data() {
    return {
      aggregate: {},
      percentOrders: {
        icon: 'none',
        value: 0
      },
      labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      orderCountArray: [],
      orderAmountArray: [],
      curGraphTab: 'today',
      months: [
        "Janeiro",
        "Fevereiro",
        "Março",
        "Abril",
        "Maio",
        "Junho",
        "Julho",
        "Agosto",
        "Setembro",
        "Outubro",
        "Novembro",
        "Dezembro",
      ],
    };
  },
  methods: {
    getIconCard(value) {
      if(value === 0) return 'none';
      return value > 0 ? 'up' : 'down';
    },
    setCurGraphTab(tab) {
      this.$data.curGraphTab = tab;
    },
    loadOrdersCardAggregation() {
      const todayMinusOneYear = sub(new Date(), { years: 1 });
      const queryOrders = firebase.firestore().collection('orders').where('status','==', 'done')
        .where('updatedAt', '>=', startOfMonth(todayMinusOneYear))
        .where('updatedAt', '<=', endOfMonth(todayMinusOneYear));

      queryOrders.get().then(querySnapshot => {
        const { totalOrdersCurMonth } = this.$data.aggregate;
        let totalOrdersSameMonthLastYear = 0;
        querySnapshot.docs.forEach(docSnapshot => {
          const { amount } = docSnapshot.data();
          totalOrdersSameMonthLastYear += amount.orderAmount; 
        });
        

        this.$data.percentOrders.value = totalOrdersSameMonthLastYear ? (totalOrdersCurMonth - totalOrdersSameMonthLastYear) / totalOrdersSameMonthLastYear : 0;
        this.$data.percentOrders.icon = this.getIconCard(this.$data.percentOrders.value);
      });
    },
    async loadAggregation() {
      if (this.userData.type === "supermarket") {
        const aggregationSnapshot = await firebase
          .firestore()
          .collection("aggregation")
          .doc(this.userData.id)
          .get();
        this.$data.aggregate = aggregationSnapshot.data();
      } else {
        const aggregationSnapshot = await firebase
          .firestore()
          .collection("aggregationAdmin")
          .doc("data")
          .get();
        this.$data.aggregate = aggregationSnapshot.data();
      }
    },
  },
  async mounted() {
    const today = new Date();
    const currentYear = today.getFullYear();
    const query = firebase.firestore().collection('orders').where('status','==', 'done')
      .where('updatedAt', '>=', new Date(currentYear, 0, 1, 0, 0, 0))
      .where('updatedAt', '<=', new Date(currentYear, 11, 31, 0, 0, 0));

    let querySnapshot;
    if(this.userData.type === 'supermarket') querySnapshot = await query.where('supermarket.id', '==', this.userData.id).get();
    else querySnapshot = await query.get();    

    const orderAmountArray = new Array(12).fill(0), orderCountArray = new Array(12).fill(0);

    querySnapshot.docs.forEach(docSnapshot => {
      const data = docSnapshot.data();
      const updatedAt = data.updatedAt.toDate();
      const index = updatedAt.getMonth();

      if(!orderCountArray[index]) orderCountArray[index] = 1;
      else orderCountArray[index] += 1;

      if(!orderAmountArray[index]) orderAmountArray[index] = data.amount.orderAmount;
      else orderAmountArray[index] += data.amount.orderAmount;
    });

    this.$data.orderCountArray = orderCountArray;
    this.$data.orderAmountArray = orderAmountArray;

    await this.loadAggregation();
    this.loadOrdersCardAggregation();

  },
};
</script>


<style lang="scss">
.stat-percent {
      &.danger {
        color: tomato;
      }

      &.zero {
        color: gray;
      }
}
</style>
